import styled from 'styled-components';

export const StyledLabel = styled.label<{ hasError: boolean, $colors?: string }>`
  color: ${({ hasError, $colors }) => (hasError ? '#ef4444' : $colors)};
  font-size: 0.875rem;
  line-height: 1.25rem;
`;

export const StyledSelect = styled.select<{ hasError: boolean, $borderColors?: string, $focusColor?: string }>`
  height: 40px;
  width: 100%;
  border-radius: 0.5rem;
  border: 1px solid ${({ hasError, $borderColors }) => (hasError ? '#ef4444' : $borderColors)};
  background-color: #fff;
  padding: 0 1rem;
  font-size: 0.875rem;
  outline: none;

  &:focus {
    border-color: ${({ $focusColor }) => $focusColor};
  }
`;
